const UploadIcon = ({ color }: { color: string }) => (
  <svg width={20} height={26} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1.95h18c.552 0 1-.437 1-.975a.984.984 0 0 0-.864-.966L19 0H1C.448 0 0 .436 0 .975c0 .493.376.901.864.966L1 1.95ZM9.846 25.99l.156.009c.683 0 1.247-.502 1.324-1.148l.01-.152V8.337l4.392 4.28a1.36 1.36 0 0 0 1.76.107l.126-.108c.48-.468.517-1.205.11-1.715l-.11-.123-6.665-6.494a1.36 1.36 0 0 0-1.76-.108l-.125.108-6.672 6.494a1.276 1.276 0 0 0-.002 1.838 1.36 1.36 0 0 0 1.76.11l.126-.109 4.392-4.274V24.7c0 .667.515 1.216 1.178 1.291Z"
      fill={color}
    />
  </svg>
);
export default UploadIcon;

export const UploadCloudIcon: React.FC<{
  color?: string;
  size?: number;
}> = ({ color, size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size ?? '24'}
    height={size ?? '24'}
    fill="none"
  >
    <path
      fill={color ?? '#7664FA'}
      d="M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 13V17H11V13H8L12 8L16 13H13Z"
    />
  </svg>
);
